"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsViewerReady = useIsViewerReady;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = require("react");

var _useReadyState3 = require("./use-ready-state");

var _useInterval = require("./use-interval");

var _useOsdEventHandler = require("./use-osd-event-handler");

function useIsViewerReady(viewer) {
  var _useReadyState = (0, _useReadyState3.useReadyState)(),
      _useReadyState2 = (0, _slicedToArray2["default"])(_useReadyState, 2),
      isReady = _useReadyState2[0],
      setIsReady = _useReadyState2[1];

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      intervalCounter = _useState2[0],
      setIntervalCounter = _useState2[1]; // Check for resize.


  (0, _useOsdEventHandler.useOsdEventHandler)(viewer, 'resize', function () {
    setIsReady(true);
  }, !isReady); // Check upfront if its working.

  (0, _react.useLayoutEffect)(function () {
    if (viewer && !isReady) {
      var x = viewer.viewport._contentSize.x;

      if (x > 1) {
        setIsReady(true);
        return;
      }
    }
  }, [isReady, setIsReady, viewer]); // If after 250ms it's still not working, we do a brute force check.

  (0, _useInterval.useInterval)(function () {
    if (viewer) {
      var x = viewer.viewport._contentSize.x;

      if (x > 1) {
        setIsReady(true);
        return;
      }
    }

    setIntervalCounter(function (c) {
      return c + 1;
    });
  }, 250, !isReady && intervalCounter < 20);
  return [isReady, setIsReady];
}